
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BagkurEmekliCevap } from '@/plugins/uyap-plugin/uyap/BagkurEmekli';

@Component({})
export default class BagkurEmekliDetay extends Vue {
  @Prop() data!: BagkurEmekliCevap;

  get emekliBilgi() {
    return this.data.sorguSonucDVO;
  }

  // DEV-3354: Bağ-Kur emekli kaydı emekliKaydi4b altında geliyor; burada SSK emeklisinin
  // alanı (emekliKaydi4AList) okunduğu için aylık bilgileri hiç görünmüyordu.
  get emekliKaydi() {
    return this.emekliBilgi?.emekliKaydi4b;
  }

  get aylikBilgileri() {
    return this.emekliKaydi?.aylikGoruntuleForm || [];
  }

  get hasData() {
    return this.emekliBilgi && (this.aylikBilgileri.length > 0 || this.emekliBilgi.hataKodu === 995);
  }

  getDurumColor(durumKoduString: string) {
    if (!durumKoduString) return 'grey';
    const durum = durumKoduString.toLowerCase();
    if (durum.includes('yapıldı') || durum.includes('onay')) return 'success';
    if (durum.includes('red') || durum.includes('iptal')) return 'error';
    return 'warning';
  }

  getOnayDurumColor(onayDurumuString: string) {
    if (!onayDurumuString) return 'grey';
    const durum = onayDurumuString.toLowerCase();
    if (durum.includes('ödeme')) return 'success';
    if (durum.includes('red')) return 'error';
    return 'warning';
  }

  getSonucType() {
    if (!this.emekliKaydi) return 'info';
    return this.emekliKaydi.sonucKod === 0 ? 'success' : 'warning';
  }
}
